module.exports = ".inline{display:flex}.dynamic{display:flex;flex-wrap:wrap}.dynamic .custom-control{flex-basis:20%}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/access-management/radio-select/radio-select.component.scss
// module id = ./src/app/access-management/radio-select/radio-select.component.scss
// module chunks = access-management.module